import { FC, ReactNode } from 'react';
import styles from '../NotificationDrawer.module.scss';
import cx from 'classnames';

interface ExpiredOrderDetailsTypes {
  getOrderTitle: (quote: boolean) => ReactNode;
}

export const ExpiredOrderDetails: FC<ExpiredOrderDetailsTypes> = ({
  getOrderTitle
}) => {
  return (
    <span
      className={cx(
        styles['expired-order-details__text'],
        `u-color--Medium Black`
      )}
      data-testid="header-notification-title"
    >
      {getOrderTitle(true)}
    </span>
  );
};
